import withListaTemasArea from '../../hoc/withTrabajadores/withListaTemasArea';
import ListaTemasArea from '../../view/components/RegistroUsuarios/Clasificacion/VistaClasificacion/ListaTemasArea';
export default withListaTemasArea(ListaTemasArea);